import { useEffect, useState } from 'react';
import Sheet from 'react-modal-sheet';
import endGame from '../assets/kraj-nagradne-igre.png';
import close from '../assets/yettel-close.png';
import { SESSION_STORAGE_KEYS } from '../constants/sessionStorageKeys';
import '../scss/end-game-modal.scss';

export const EndOfGameModal = () => {
  const [isPrizePopupActive, setIsPrizePopupActive] = useState(false);

  const isModalSeen = () => {
    return sessionStorage.getItem(SESSION_STORAGE_KEYS.IS_ENDGAME_MODAL_SEEN) === 'true';
  };

  const closeModal = () => {
    sessionStorage.setItem(SESSION_STORAGE_KEYS.IS_ENDGAME_MODAL_SEEN, 'true');
    setIsPrizePopupActive(false);
  };

  useEffect(() => {
    if (!isModalSeen()) {
      setIsPrizePopupActive(true);
    }
  }, []);

  return (
    <>
      <Sheet isOpen={isPrizePopupActive} onClose={closeModal} className="end-game-modal">
        <Sheet.Container>
          <Sheet.Content>
            <img src={endGame} alt="endGame" />

            <img
              className="close-icon cursor-pointer"
              src={close}
              alt="close"
              onClick={closeModal}
              width="30"
              height="30"
            />
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={closeModal} />
      </Sheet>
    </>
  );
};
